// 🚀 Orval 자동 생성 React Query 훅 사용 - useInfiniteQuery 수동 구현 제거!
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { useGetRoadmapsInfinite } from '@edusense/course-client';
import { getLocale } from '@paraglide/runtime';
/**
 * 🚀 완전 자동화된 로드맵 데이터 훅 - Orval + React Query 
 * 기존의 복잡한 상태관리와 API 호출 로직을 완전히 제거하고 
 * 자동 생성된 React Query 훅을 사용합니다.
 */ export function useRoadmapData() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_type = _ref.type, type = _ref_type === void 0 ? 'Featured' : _ref_type, userId = _ref.userId, categoryId = _ref.categoryId, searchQuery = _ref.searchQuery, _ref_pageSize = _ref.pageSize, pageSize = _ref_pageSize === void 0 ? 10 : _ref_pageSize, _ref_enabled = _ref.enabled, enabled = _ref_enabled === void 0 ? true : _ref_enabled;
    var _data_pages, _data_pages1;
    // Get current language for query key to trigger refetch on language change
    var currentLanguage = getLocale().split('-')[0];
    // API 타입 매핑
    var mapToGetRoadmapsType = function(filterType) {
        switch(filterType){
            case 'Featured':
                return 'popular'; // Featured를 popular로 매핑
            case 'Popular':
                return 'popular';
            case 'New':
                return 'popular'; // New도 popular로 매핑 (API에 new가 없음)
            case 'User':
                return 'created_by_user';
            case 'Subscribed':
                return 'subscribed_by_user';
            default:
                return 'popular';
        }
    };
    // 🚀 Orval 자동 생성 무한 스크롤 훅 사용 - 수동 구현 완전 제거!
    var _useGetRoadmapsInfinite = useGetRoadmapsInfinite(// API 파라미터 - 첫 번째 인자
    _object_spread({
        page: 0,
        size: pageSize,
        listType: mapToGetRoadmapsType(type)
    }, userId && {
        userId: userId
    }, categoryId && {
        categoryId: categoryId
    }, searchQuery && {
        query: searchQuery
    }), // React Query 옵션 - 두 번째 인자
    {
        query: {
            queryKey: [
                'roadmaps',
                type,
                userId,
                categoryId,
                searchQuery,
                currentLanguage
            ],
            getNextPageParam: function(lastPage) {
                var _lastPage_data;
                // API 응답에서 다음 페이지 정보 추출
                var pagination = (_lastPage_data = lastPage.data) === null || _lastPage_data === void 0 ? void 0 : _lastPage_data.pagination;
                if (!pagination || pagination.last) {
                    return undefined; // 마지막 페이지
                }
                return (pagination.number || 0) + 1;
            },
            initialPageParam: 0,
            enabled: enabled,
            staleTime: 1000 * 60 * 5,
            gcTime: 1000 * 60 * 30
        }
    }), data = _useGetRoadmapsInfinite.data, isLoading = _useGetRoadmapsInfinite.isLoading, error = _useGetRoadmapsInfinite.error, fetchNextPage = _useGetRoadmapsInfinite.fetchNextPage, hasNextPage = _useGetRoadmapsInfinite.hasNextPage, isFetchingNextPage = _useGetRoadmapsInfinite.isFetchingNextPage, refetch = _useGetRoadmapsInfinite.refetch;
    // 🎯 데이터 변환 - FIX: page.data.roadmaps → page.roadmaps
    var transformedData = (data === null || data === void 0 ? void 0 : (_data_pages = data.pages) === null || _data_pages === void 0 ? void 0 : _data_pages.flatMap(function(page) {
        var _page_roadmaps;
        return (page === null || page === void 0 ? void 0 : (_page_roadmaps = page.roadmaps) === null || _page_roadmaps === void 0 ? void 0 : _page_roadmaps.map(function(item) {
            var _item_creator_basicInfo, _item_creator_basicInfo1, _item_creator_basicInfo2, _item_creator_basicInfo3;
            var _item_description, _item_isSubscribed;
            return {
                id: String(item.id),
                title: item.title,
                description: (_item_description = item.description) !== null && _item_description !== void 0 ? _item_description : undefined,
                creator: item.creator ? {
                    id: String(((_item_creator_basicInfo = item.creator.basicInfo) === null || _item_creator_basicInfo === void 0 ? void 0 : _item_creator_basicInfo.id) || ''),
                    username: ((_item_creator_basicInfo1 = item.creator.basicInfo) === null || _item_creator_basicInfo1 === void 0 ? void 0 : _item_creator_basicInfo1.username) || '',
                    displayName: ((_item_creator_basicInfo2 = item.creator.basicInfo) === null || _item_creator_basicInfo2 === void 0 ? void 0 : _item_creator_basicInfo2.displayName) || '',
                    profileImageUrl: (_item_creator_basicInfo3 = item.creator.basicInfo) === null || _item_creator_basicInfo3 === void 0 ? void 0 : _item_creator_basicInfo3.profileImageUrl
                } : undefined,
                courseCount: typeof item.courseCount === 'string' ? parseInt(item.courseCount, 10) || 0 : item.courseCount || 0,
                isSubscribed: (_item_isSubscribed = item.isSubscribed) !== null && _item_isSubscribed !== void 0 ? _item_isSubscribed : false,
                subscriptionCount: typeof item.subscriptionCount === 'string' ? parseInt(item.subscriptionCount, 10) || 0 : item.subscriptionCount || 0,
                createdAt: item.createdAt || new Date().toISOString(),
                updatedAt: item.updatedAt || new Date().toISOString()
            };
        })) || [];
    })) || [];
    return {
        data: transformedData,
        isLoading: isLoading,
        error: error,
        fetchNextPage: fetchNextPage,
        hasNextPage: hasNextPage,
        isFetchingNextPage: isFetchingNextPage,
        refresh: refetch,
        observerRef: null,
        // 기존 인터페이스 호환성
        pagination: {
            last: !hasNextPage,
            totalPages: (data === null || data === void 0 ? void 0 : (_data_pages1 = data.pages) === null || _data_pages1 === void 0 ? void 0 : _data_pages1.length) || 0,
            totalElements: transformedData.length
        }
    };
}
